import { IconButton } from '../Buttons';
import { Row } from '../Containers';
import { ChevronLeftIcon, ChevronRightIcon } from '../Icons';

import { useTable } from './Table';

function TablePagination(): JSX.Element | null {
  const { page, itemsPerPage, items, hidePagination, dispatch } = useTable();

  const actualItemsPerPage = hidePagination ? items.length : itemsPerPage;

  const lastPage = Math.ceil(items.length / actualItemsPerPage);

  const actualPage = lastPage < page ? lastPage : page;

  const humanPage = actualPage + 1;

  if (!items.length) return null;

  return (
    <Row gap="2" justifyContent="flex-end">
      <IconButton
        size="small"
        onClick={() =>
          dispatch({
            page: actualPage > 0 ? actualPage - 1 : actualPage,
          })
        }
      >
        <ChevronLeftIcon size={16} color="primary" />
      </IconButton>

      <span className="text-sm text-muted-foreground">
        {humanPage} / {lastPage}
      </span>

      <IconButton
        size="small"
        onClick={() =>
          dispatch({
            page: actualPage < lastPage - 1 ? actualPage + 1 : actualPage,
          })
        }
      >
        <ChevronRightIcon size={16} color="primary" />
      </IconButton>
    </Row>
  );
}

export default TablePagination;
